import React from 'react'
import { Form,  } from 'react-bootstrap'

const TextSearchParam = ({
    label,
    value = '',
    onChange = () => {}
}) => {
    return (
        <Form.Group>
            <Form.Label>{label || 'School Year'}</Form.Label>
            <Form.Control
                value={value}
                onChange={e => onChange(e.target.value)}
            />
        </Form.Group>
    )
}

export default TextSearchParam